module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isDataAvailable) ? _c('loader', {
    staticStyle: {
      "min-height": "100px"
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "workflowSubmit"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.hasAtLeastOneNextStatus) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('workflowSubmit.workflowStatusId')
    },
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Action")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowStatusId),
      expression: "workflowStatusId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "workflowStatusId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.workflowStatusId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select action")]), _vm._v(" "), _vm._l((_vm.workflowStatusDtoNextList), function(item) {
    return _c('option', {
      key: item.workflowStatusId,
      domProps: {
        "value": item.workflowStatusId
      }
    }, [_vm._v("\n                        " + _vm._s(item.submitDescription) + "\n                    ")])
  })], 2), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('workflowSubmit.workflowStatusId')),
      expression: "errors.has('workflowSubmit.workflowStatusId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Next Status is required")])])])]) : _vm._e(), _vm._v(" "), (_vm.workflowStatusId === 3800 && !_vm.isUserShpo) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                WARNING: By submitting to QA/QC Review, you will not receive SHPO review.\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.assignableUserList.length > 0) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('workflowSubmit.assignedUserId')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Assign User")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignedUserId),
      expression: "assignedUserId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "assignedUserId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignedUserId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select user to assign")]), _vm._v(" "), _vm._l((_vm.assignableUserList), function(item) {
    return _c('option', {
      key: item.userId,
      domProps: {
        "value": item.userId
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                    ")])
  })], 2), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('workflowSubmit.assignedUserId')),
      expression: "errors.has('workflowSubmit.assignedUserId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Assign User is required")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUndertakingAssignable),
      expression: "isUndertakingAssignable"
    }],
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isUndertakingAssignable) ? _c('undertakingModal', {
    ref: "undertakingModal"
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.hasAtLeastOneNextStatus) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('workflowSubmit.notes')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Note")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.noteValidationRules),
      expression: "noteValidationRules"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "notes",
      "placeholder": "Notes"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('workflowSubmit.notes')),
      expression: "errors.has('workflowSubmit.notes')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Notes are required")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canCloseUndertaking),
      expression: "canCloseUndertaking"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label checkbox-label"
  }, [_vm._v("Close undertaking?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeUndertaking),
      expression: "closeUndertaking"
    }],
    attrs: {
      "type": "checkbox",
      "id": "undertakingcheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.closeUndertaking) ? _vm._i(_vm.closeUndertaking, null) > -1 : (_vm.closeUndertaking)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.closeUndertaking,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.closeUndertaking = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.closeUndertaking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.closeUndertaking = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canCloseE106),
      expression: "canCloseE106"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label checkbox-label"
  }, [_vm._v("Close E106 Compliance?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeE106),
      expression: "closeE106"
    }],
    attrs: {
      "type": "checkbox",
      "id": "e106checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.closeE106) ? _vm._i(_vm.closeE106, null) > -1 : (_vm.closeE106)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.closeE106,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.closeE106 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.closeE106 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.closeE106 = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canReturnSites),
      expression: "canReturnSites"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label checkbox-label"
  }, [_vm._v("Return All Sites?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnSites),
      expression: "returnSites"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sitescheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.returnSites) ? _vm._i(_vm.returnSites, null) > -1 : (_vm.returnSites)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.returnSites,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.returnSites = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.returnSites = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.returnSites = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('validationResultDisplay', {
    attrs: {
      "validationResult": _vm.validationResult
    }
  })], 1)]), _vm._v(" "), (_vm.hasAtLeastOneNextStatus) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkFieldWorkRequestErrors),
      expression: "checkFieldWorkRequestErrors"
    }],
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "has-error",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Form must be completed prior to submit")])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.workflowSubmit
    }
  }, [_vm._v("Submit")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }],
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ****** - " + _vm._s(_vm.componentName))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Validation errors: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.errors))]), _vm._v("\n        noteValidationRules"), _c('br'), _c('pre', [_vm._v(_vm._s(_vm.noteValidationRules))])]), _vm._v(" "), _c('div', [_vm._v("\n        workflowStatusId: " + _vm._s(_vm.workflowStatusId)), _c('br'), _vm._v("\n        selectedWorkflowStatusDto: "), _c('pre', [_vm._v(_vm._s(_vm.selectedWorkflowStatusDto))]), _c('br'), _vm._v("\n        workflowStatusDtoNextList"), _c('br'), _c('pre', [_vm._v(_vm._s(_vm.workflowStatusDtoNextList))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78a27b50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/workflowSubmit.vue
// module id = 964
// module chunks = 1